// extracted by mini-css-extract-plugin
export default {"routesContainer":"profile_sidebar_routesContainer__GOsHc","routes":"profile_sidebar_routes__Zxn4m","logoutBtn":"profile_sidebar_logoutBtn__LeaH3"};